//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    page: { validator: prop => typeof prop === 'string' || prop === undefined || prop === null, default: null }
  },
  data () {
    return {
      activeArticleId: null
    }
  },
  async fetch () {
    await this.$store.dispatch('support/GET', this.page)
  },
  computed: {
    categories () { return this.$store.getters['support/categories'](this.page) },
    articles () { return this.$store.getters['support/articles'](this.page) || [] },
    activeArticle () { return this.articles.find(article => (article || {}).id === this.activeArticleId) || {} }
  },
  watch: {
    activeArticle (article) {
      console.log('activeArticle', this.slugify(article.title || ''))
      if (Object.keys(article).length) {
        history.replaceState({}, null, `${this.$route.path}#/${article.id}/${this.slugify(article.title)}`)
      } else {
        history.replaceState({}, null, `${this.$route.path}`)
      }
    }
  },
  mounted () {
    try {
      if (this.$route.hash && this.$route.hash.includes('#/')) {
        this.activeArticleId = parseInt(this.$route.hash.split('#/')[1].split('/')[0])
  
        if (this.activeArticle) {
          // We have an active article - find the first category it is shown in, expand it then scroll into view
          const category = this.categories.find(category => category.articles.find(article => article.id === this.activeArticleId))
          const categoryComponent = this.$refs[`category${category.id}`][0]
          categoryComponent.expand(this.activeArticleId)
  
          this.$nextTick(() => {
            this.$scrollTo(`#article-${this.activeArticleId}`, { duration: 600, force: false })
          })
        }
      }
    } catch (error) {
      this.$sentry.captureException(error)
    }
  },
  methods: {
    toggle (article, state) {
      if (state) {
        // An article has been opened, set it as the activeArticle
        this.activeArticleId = article.id
      } else if (this.activeArticleId === article.id) {
        // Article has been closed, if it's the activeArticle then set to null else do nothing
        this.activeArticleId = null
      }
    }
  }
}
